<aum-cli-spinner [isLoading]="isLoading"></aum-cli-spinner>
<form
  [formGroup]="form"
  (ngSubmit)="submitForm()"
  fxLayout="column"
  fxFlexAlign="space-around flex-start"
  class="payment-password-confirmation-wrapper p-40"
>
  <div class="text-wrapper mb-50">
    <div class="title text-yellow font-22 bold font-chakra">
      {{ data?.title | translate }}
    </div>
    <div class="message text-gray font-15 mt-15">
      {{ data?.message | translate }}
    </div>
    <div class="password-container">
      <mat-form-field class="w-full mt-20">
        <mat-label>{{ 'buySell.confirmPasswordTitle' | translate }}</mat-label>
        <input
          formControlName="password"
          matInput
          [type]="inputType"
          required
        />
        <button
          class="visibility-button"
          mat-icon-button
          type="button"
          matSuffix
          (click)="toggleVisibility()"
        >
          <mat-icon>{{ visible ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        <mat-error>
          <mat-error>
            <aum-cli-form-field-error
              [formGroup]="form"
              [field]="'password'"
              [translatePfx]="'registration'"
            ></aum-cli-form-field-error>
          </mat-error>
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="actions-wrapper w-full"
  >
    <button
      [mat-dialog-close]="false"
      class="cancel-btn px-50"
      mat-raised-button
      type="button"
    >
      {{ 'general.cancel' | translate | uppercase }}
    </button>
    <button
      class="aum-button px-50 w-300 confirm-btn"
      color="primary"
      mat-raised-button
      type="submit"
      [disabled]="!form.valid"
    >
      {{ 'general.ok' | translate | uppercase }}
    </button>
  </div>
</form>
